import React, { Dispatch } from 'react';
import { CaseProcedureModel } from '../../../lib/models/CaseProcedureModel';
import AppealProcedureListing from './AppealProcedureListing';
import InitialReviewProcedureListing from './InitialReviewProcedureListing';

export type CaseProcedureListingProps = {
    procedureList: CaseProcedureModel[] | undefined;
    crmId: string | undefined;
    crmClientName?: string;
    caseStage: string;
    // eslint-disable-next-line
    handleReasonDenialChange: any;
    setAnyChangeMade: Dispatch<boolean>;
};

function CaseProcedureListing({
    procedureList,
    crmId,
    crmClientName,
    caseStage,
    handleReasonDenialChange,
    setAnyChangeMade
}: CaseProcedureListingProps) {
    function renderSwitch(param: string) {
        switch (param) {
            case 'Initial':
                return (
                    <InitialReviewProcedureListing
                        procedureList={procedureList}
                        crmId={crmId}
                        crmClientName={crmClientName}
                        caseStage={caseStage}
                        handleReasonDenialChange={handleReasonDenialChange}
                        setAnyChangeMade={setAnyChangeMade}
                    />
                );
            case 'First Level Appeal':
                return (
                    <AppealProcedureListing
                        procedureList={procedureList}
                        crmId={crmId}
                        crmClientName={crmClientName}
                        caseStage={caseStage}
                        handleReasonDenialChange={handleReasonDenialChange}
                        setAnyChangeMade={setAnyChangeMade}
                    />
                );
            default:
                return (
                    <AppealProcedureListing
                        procedureList={procedureList}
                        crmId={crmId}
                        crmClientName={crmClientName}
                        caseStage={caseStage}
                        handleReasonDenialChange={handleReasonDenialChange}
                        setAnyChangeMade={setAnyChangeMade}
                    />
                );
        }
    }

    return <>{renderSwitch(caseStage)}</>;
}

export default CaseProcedureListing;
